import { OnInit, ElementRef, OnDestroy, ChangeDetectorRef, OnChanges } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { SocialService } from '../../services/social.service';
import { AppComponent } from 'src/app/app.component';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isChildOf } from '../../utilities/html.utilities';
import { Languages } from '../../enums/languages';
import { UsersService } from '../../services/users.service';
import { AuthEventsEmitter } from '../../events/auth.events';
import { MasterService } from '../../services/master.service';
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(config, authService, changeDetectorRef, socialService, router, usersService, authEventsEmitter, masterService) {
        this.config = config;
        this.authService = authService;
        this.changeDetectorRef = changeDetectorRef;
        this.socialService = socialService;
        this.router = router;
        this.usersService = usersService;
        this.authEventsEmitter = authEventsEmitter;
        this.masterService = masterService;
        this.headerToggledClass = 'header-toggled';
        this.profileImageSrc = '/assets/images/avatar.png';
        this.languages = Object.keys(Languages).map(function (k) { return Languages[k]; });
        this.subscriptions = [];
        this.haveMasterProfile = false;
        this.isDiaryChangeDisabled = false;
        this.isUserUnderMasterProfile = false;
        this.isUserOnCatering = false;
        this.userHasSport = false;
        config.placement = 'bottom-right';
        this.mutePage();
    }
    NavbarComponent.prototype.ngOnChanges = function () {
        this.mutePage();
        this.changeDetectorRef.detectChanges();
    };
    NavbarComponent.prototype.mutePage = function () {
        var elems = document.querySelectorAll('video, audio');
        [].forEach.call(elems, function (elem) {
            elem.muted = true;
            elem.pause();
        });
    };
    NavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        // const containerScroller: HTMLElement = document.querySelector('.container-scroller');
        this.mutePage();
        // check if user is under master profile
        this.masterService.checkIsSubAccountUnderMaster().subscribe(function (success) {
            _this.isUserUnderMasterProfile = true;
        });
        this.usersService.getUserCateringMeals().subscribe(function (data) {
            _this.isUserOnCatering = (data && data.length > 0);
        });
        // Horizontal menu fixed when scrolling
        this.subscriptions.push(fromEvent(document.body, 'scroll').subscribe(function () {
            if (document.body.scrollTop >= _this.wrapper.nativeElement.offsetHeight) {
                _this.wrapper.nativeElement.classList.add('fixed-on-scroll');
            }
            else {
                _this.wrapper.nativeElement.classList.remove('fixed-on-scroll');
            }
        }));
        this.subscriptions.push(this.router.events.pipe(filter(function (e) { return e instanceof NavigationStart && !!_this.bottomNavbar; }))
            .subscribe(function () {
            _this.bottomNavbar.nativeElement.classList.remove(_this.headerToggledClass);
        }));
        // Horizontal menu navigation in mobile menu on click
        var navItemClicked = document.querySelectorAll('.horizontal-menu .page-navigation >.nav-item');
        navItemClicked.forEach(function (el) {
            el.addEventListener('click', function () {
                navItemClicked.forEach(function (subel) {
                    subel.classList.remove('show-submenu');
                });
                if (window.matchMedia('(max-width: 991px)').matches) {
                    el.classList.toggle('show-submenu');
                }
            });
        }, false);
        this.subscriptions.push(this.router.events.pipe(filter(function (e) { return e instanceof NavigationEnd; }))
            .subscribe(function () {
            _this.changeDetectorRef.detectChanges();
        }));
        this.usersService.getUserSport().subscribe(function (sport) {
            _this.userHasSport = true;
            _this.changeDetectorRef.markForCheck();
        }, function () {
            _this.userHasSport = false;
            _this.changeDetectorRef.markForCheck();
        });
        if (this.socialService.userIsLoggedInFacebook) {
            this.subscriptions.push(this.socialService.getFacebookProfilePictureUrl(this.socialService.facebookId)
                .subscribe(function (src) {
                _this.profileImageSrc = src;
                _this.changeDetectorRef.markForCheck();
            }));
        }
        var dis = false;
        this.haveMasterProfile = window.location.href.includes('master');
        if (this.authService.getStorageItem('master_sub_profile_logged_token')
            && this.authService.getStorageItem('master_sub_profile_logged_token').length > 0
            && window.location.href.includes('master/meals')) {
            dis = true;
            this.usersService.getMasterUserProfile().subscribe(function (profile) {
                _this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;
                if (profile && profile.is_master_profile === true) {
                    _this.haveMasterProfile = true;
                    _this.changeDetectorRef.markForCheck();
                }
                _this.changeDetectorRef.markForCheck();
            });
        }
        else {
            this.usersService.getUserProfile().subscribe(function (profile) {
                // this.haveMasterProfile = profile && profile.is_master_profile;
                _this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;
                if (profile && profile.is_master_profile === true) {
                    _this.haveMasterProfile = true;
                    _this.changeDetectorRef.markForCheck();
                }
                _this.changeDetectorRef.markForCheck();
            });
        }
        if (dis === false) {
            this.authEventsEmitter.userProfileChanged$
                .subscribe(function () {
                _this.usersService.getUserProfile(true).subscribe(function (profile) {
                    // this.haveMasterProfile = profile && profile.is_master_profile;
                    _this.isDiaryChangeDisabled = profile && profile.is_master_profile === false && profile.is_change_diary_disabled === true;
                    _this.changeDetectorRef.markForCheck();
                });
            });
        }
    };
    NavbarComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    Object.defineProperty(NavbarComponent.prototype, "completeHeader", {
        get: function () {
            return this.appComponent.completeHeader;
        },
        enumerable: true,
        configurable: true
    });
    NavbarComponent.prototype.toggleRightSidebar = function () {
        document.querySelector('.bottom-navbar').classList.toggle('header-toggled');
    };
    NavbarComponent.prototype.onLogout = function () {
        this.authService.logout();
    };
    NavbarComponent.prototype.onWebChat = function () {
        document.body.classList.remove('hide-tidio-chat');
        window['tidioChatApi'].open();
        document.addEventListener('tidioChat-close', function () {
            document.body.classList.add('hide-tidio-chat');
        });
    };
    NavbarComponent.prototype.onLanguageSelected = function (locale) {
        var _this = this;
        this.usersService.updateUserProfile({
            locale: locale
        })
            .subscribe(function () {
            window.location.href = _this.router.url;
        });
    };
    NavbarComponent.prototype.flagIcon = function (language) {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    };
    NavbarComponent.prototype.onWindowClick = function (e) {
        if (!this.wrapper) {
            return;
        }
        if (!this.bottomNavbar) {
            return;
        }
        var target = e.target;
        var nativeElement = this.wrapper.nativeElement;
        if (target !== nativeElement && !isChildOf(nativeElement, target)) {
            this.bottomNavbar.nativeElement.classList.remove(this.headerToggledClass);
        }
    };
    return NavbarComponent;
}());
export { NavbarComponent };
